export default __webpack_public_path__ + "static/media/sm-logo-retina.7dc29d0c.webp";